import type { components } from "@/types/api.generated";
import apiClient from "./client";

/**
 * Usuários ativos do Diagnóstico, com tipo, papéis e SKU sugerido (#1478).
 *
 * Aliases sobre os tipos gerados do OpenAPI: o contrato mora no backend
 * (`routers/active_users.py`).
 */
export type ActiveUser = components["schemas"]["ActiveUser"];
export type TechnicalActiveUser = components["schemas"]["TechnicalActiveUser"];
export type ActiveUsers = components["schemas"]["ActiveUsers"];

/**
 * `GET /api/projects/{projectId}/active-users`.
 *
 * Projeto sem execução concluída do Functional responde 200 com as listas vazias.
 */
export async function getActiveUsers(projectId: string): Promise<ActiveUsers> {
  const res = await apiClient.get<ActiveUsers>(`/api/projects/${projectId}/active-users`);
  return res.data;
}
